// extracted by mini-css-extract-plugin
export default {"label":"LabelChoice_label__uFHhq","gochi":"LabelChoice_gochi__-6FDh","inactive":"LabelChoice_inactive__-4RCK"};